import { Side } from '@/compiled_proto/com/celertech/positionmanager/api/enums/SideProto';
import { InferType, object } from 'yup';
import { Nullable } from '../../../model/common';
import { PriceSchemaParams, QuantitySchemaParams, priceSchema, quantitySchema } from './common';
import { stopPriceSchema } from './ocoOrderSchema';

interface AmendOCOOrderSchemaParams extends PriceSchemaParams, QuantitySchemaParams {}

export const amendOCOOrderSchema = (
    params: AmendOCOOrderSchemaParams,
    priceOptions: {
        side: Side;
        bestAsk: number;
        bestBid: number;
        formattedBestAsk: string;
        formattedBestBid: string;
        ccy2Order: boolean;
    }
) => {
    return object({
        order1: object({
            price: priceSchema(params),
            stopPrice: priceSchema(params),
            quantity: quantitySchema(params)
        }),
        order2: object({
            price: priceSchema(params),
            stopPrice: stopPriceSchema(priceOptions),
            quantity: quantitySchema(params)
        })
    });
};

export type AmendOCOOrderFormValues = InferType<ReturnType<typeof amendOCOOrderSchema>>;
export type AmendOCOOrderFormInput = Nullable<AmendOCOOrderFormValues>;
